import { BLACK_COLOR } from '../../../utils/constants'

const PieceIcon = () => (
  <svg
    width="27"
    height="15"
    viewBox="0 0 27 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="24.7857"
      height="13"
      rx="3"
      stroke={BLACK_COLOR}
      strokeWidth="2"
    />
  </svg>
)

export default PieceIcon
